import React, { FC } from "react";
import FormDialog from "layout-form-dialog";
import {
  Typography,
  useTheme,
  useMediaQuery,
  Theme,
  Grid
} from "@mui/material";
import useRHStyles from "hooks/useRHStyles";
import {
  NotificationVariant,
  NotificationContent,
  ErrorInfo
} from "./RHNotificationContext";
import ErrorIcon from "icon-error";
import SuccessIcon from "icon-success-checkmark";
import memoize from "utils/memoize";
import { useAppId } from "@RHCommerceDev/hooks/useAppId";

interface RHNotificationProps {
  open: boolean;
  title: string;
  content: NotificationContent;
  variant: NotificationVariant;
  errorInfo?: ErrorInfo;
  handleClose: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void;
}

const RHNotification: FC<RHNotificationProps> = ({
  open,
  title,
  content,
  variant,
  errorInfo,
  handleClose
}) => {
  const rhClasses = useRHStyles({
    keys: ["rhNotificationDialogFixedHeight", "fullHeight", "bottomMargin"]
  });
  const theme = useTheme();
  const smDown = useMediaQuery<Theme>(theme => theme.breakpoints.down("sm"));
  const { isConcierge } = useAppId();

  return (
    <FormDialog
      open={open}
      fullScreen={smDown}
      onClose={(event, reason) => handleClose(event, reason)}
      maxWidth="sm"
    >
      <Grid
        direction="column"
        container
        alignItems="center"
        justifyContent="center"
      >
        <Typography style={{ marginBottom: theme.spacing(1) }}>
          {variant === "warning" && "warning"}
          {variant === "success" && (
            <SuccessIcon style={{ fontSize: theme.typography.pxToRem(64) }} />
          )}
          {variant === "error" && (
            <ErrorIcon style={{ fontSize: theme.typography.pxToRem(64) }} />
          )}
        </Typography>
        <Typography
          variant="h4"
          style={{ marginBottom: theme.spacing(1), textAlign: "center" }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          align="center"
          style={{ marginBottom: theme.spacing(1) }}
        >
          {content}
        </Typography>
        {isConcierge && (
          <Typography
            variant="body1"
            align="center"
            style={{ marginBottom: theme.spacing(1) }}
          >
            {`Trace ID: ${errorInfo?.trace_id || "-"} | Timestamp: ${
              errorInfo?.timestamp || "-"
            }`}
          </Typography>
        )}
      </Grid>
    </FormDialog>
  );
};

export default memoize(RHNotification, { deep: false });
